module.exports = __webpack_public_path__ + "static/media/WoofGang.d64929de.ico";